<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-free-delivery"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base" v-if="donateModel">
                <div class="modal-base-head">
                    <div class="icon-close" @click="close()">
                        <img class="img-fluid" src="@/assets/icon/otp_icon_close@2x.png">
                    </div>
                    <div class="text-headline">{{lbl.shipping.draw_modal_success.title}}</div>
                </div>
                <div class="modal-base-image">
                    <img :src="donateModel.campaignImgUrl" class="img-fluid">
                </div>
                <div class="modal-base-body text-delivery">
                    <div class="text-delivery">
                        <div v-html="donateModel.privilegeMessageEn" v-if="donateModel.privilegeMessageEn"></div>
                        <!-- <div v-html="lbl.shipping.draw_modal_success.text"></div>
                        <span v-html="lbl.shipping.draw_modal_success.date"></span> -->
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div id="draw_delivery_bzbslogo">
                        <img src="@/assets/bzbslogo/bzbs-new-logo.svg" alt="">
                    </div>
                    <div class="btn-view-reward" @click="clickOk()">
                        <div class="btn-txt">
                            {{lbl.shipping.draw_modal_success.btn_view}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
import Moment from 'moment';
//helper
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';

export default {
    name: 'DonateSuccessModal',
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            donateModel: {},
            tag: null,

            headline: '',
            deliveryMessage: '',
            isDelivery: false,

            privilegeMessage: '',
            isPrivilegeMessage: false,

            busModal: null,

            totalPoints: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        close: function () {
            this.hide();
        },
        initial: function () {
            if(this.donateModel.privilegeMessage) {
                this.isPrivilegeMessage = true;
                this.privilegeMessage= this.donateModel.privilegeMessage;
            } else {
                if(this.donateModel.delivered == true) {
                    this.isDelivery = true;
                    this.deliveryMessage = this.lbl.serial.delivery;
                }

                if(this.donateModel.type == Vue.CampaignType.Draw) {
                    this.isPrivilegeMessage = true;
                    this.privilegeMessage = this.getDrawMessage();
                }
            }

            this.$bvModal.show(this.modalId);
        },
        getDrawMessage: function () {
            var expireDate = this.donateModel.campaignExpiredTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var day = result.format('DD');
            var month = result.format('MM');
            var date = `${day} ${month} ${year} - ${result.format('HH:mm')}`;

            return Util.stringFormat(this.lbl.serial.draw, date);
        },
        show: function (config) {
            this.donateModel = config.donateModel;
            this.tag = config.tag;

            this.initial();
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
        clickOk: function () {
            this.hide();
            this.$router.push('/luckydraw');
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/input/BaseButton.scss';
@import "@/style/base/baseImage.scss";
.modal-free-delivery {
    .modal-body{
        .modal-base-head{
            .icon-check{
                padding: 40px 0 20px;
                img{
                    width: 62px;
                }
            }
            .icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                img{
                    width: 18px;
                }
            }
            .text-headline {
                font-family: 'Medium';
                font-size: 20px;
                color: #052938;
                padding: 40px 0 20px;
            }
        }

        .modal-base-image {
            @include baseRatioImg(66.66%);
            border: 1px solid $border-gray;
            border-radius: 15px;
            box-shadow: $box-shadow;
        }

        .modal-base-body{
            font-family: $medium;
            font-size: 1.25rem;

            @include mini-mobile(){
                font-size: 1.1rem;
            }

            .text-title{
                color: $green;
            }
            .text-delivery{
                color: $bright-gray;
                padding: 15px 20px;
            }
        }

        .modal-base-footer {
            #draw_delivery_bzbslogo {
                margin-bottom: 30px;
                img {
                    max-width: 98px;
                    max-height: 26px;
                }
            }

        }

        .btn-view-reward{
            @include btn-wrapper();
            width: 100%;
            margin: 0 auto 30px;

            background-color: $white;
            border: 2px solid $blue-gray;
            .btn-txt{
                color: $blue-gray;
            }
        }
    }
}
</style>
<style lang="scss">
.modal-free-delivery{
    .modal-body{
        padding: 0 20px;
        margin: auto;
        text-align: center;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

}
</style>

